import { Group } from "three";
import { RotationPlaneToolConfig as Config } from "../Config/RotationPlaneToolConfig.js";
import { Consts } from "../Utils/Consts.js";
import { VectorUtils } from "../Utils/VectorUtils.js";
import { Circle } from "./Primitive/Circle.js";
import { DraggablePoint } from "./Primitive/DraggablePoint.js";
import { LinePointToPoint } from "./Primitive/LinePointToPoint.js";
/**
 * Tool that allow to rotate the plane.
 */
export class RotationPlaneTool extends Group /*implements Tool*/ {
    constructor(viewType, plane) {
        super();
        this.name = "RotationPlaneTool";
        this._plane = plane;
        this.add(this.A = new DraggablePoint("A", viewType, Config.A_color), this.B = new DraggablePoint("B", viewType, Config.B_color), this.C = new DraggablePoint("C", viewType, Config.C_color), this.D = new DraggablePoint("D", viewType, Config.D_color), this.ABLine = new LinePointToPoint("ACLine", Config.ABLine_color, this.A, this.B), this.BCLine = new LinePointToPoint("BCLine", Config.BCLine_color, this.B, this.C), this.CDLine = new LinePointToPoint("CDLine", Config.CDLine_color, this.C, this.D), this.DALine = new LinePointToPoint("DALine", Config.DALine_color, this.D, this.A), this._circle = new Circle("circle", Config.circle_color));
        this.bindEvents();
        this.visible = false;
    }
    /**
     * Starts the tool execution.
     */
    start() {
        this.updateVertices();
        this._circle.positions = [this.A.position, this.getMaxDistanceFromA()];
        this.visible = true;
    }
    /**
     * Ends the tool execution.
     */
    confirm() {
        this.visible = false;
    }
    bindEvents() {
        this.bindEvent("onDragMove", (args) => {
            args.preventDefault = true;
        });
        this.A.bindEvent("onDragMove", (args) => {
            this.updateRotation(args.position, this.A);
        });
        this.B.bindEvent("onDragMove", (args) => {
            this.updateRotation(args.position, this.B);
        });
        this.C.bindEvent("onDragMove", (args) => {
            this.updateRotation(args.position, this.C);
        });
        this.D.bindEvent("onDragMove", (args) => {
            this.updateRotation(args.position, this.D);
        });
    }
    updateRotation(vector, point) {
        const angle = VectorUtils.linesAngleFromOrigin(point.position, vector);
        const shapeOrigin = this._plane.position.clone();
        this._plane.rotateZ(angle);
        this._plane.position.sub(shapeOrigin).add(shapeOrigin.applyAxisAngle(Consts.planeNormal, angle));
        this.updateVertices();
    }
    updateVertices() {
        const { A, B, C, D } = this._plane.getVertices(0);
        this.A.position.copy(A);
        this.B.position.copy(B);
        this.C.position.copy(C);
        this.D.position.copy(D);
    }
    getMaxDistanceFromA() {
        const vertices = [this.B.position, this.C.position, this.D.position];
        let maxDistance = 0, maxDistanceVec;
        for (let i = 1; i < vertices.length; i++) {
            const distance = this.A.position.distanceTo(vertices[i]);
            if (distance > maxDistance) {
                maxDistance = distance;
                maxDistanceVec = vertices[i];
            }
        }
        return maxDistanceVec; // TODO check better
    }
}
//# sourceMappingURL=RotationPlaneTool.js.map